<template>
  <div>
    <AppNavDash @click-drawer="onClickDrawer" />
    <DashboardDrawer :drawer="drawer" />
    <v-main>
      <slot />
    </v-main>
    <v-snackbar
      :color="snackAlert.success ? 'success' : 'error'"
      v-model="snackAlert.status"
      timeout="2000"
    >
      {{ snackAlert.message }}
    </v-snackbar>
  </div>
</template>

<script>
import DashboardDrawer from "@/components/dashboard/DashboardDrawer";
import AppNavDash from "@/components/AppNavDash";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    drawer: null,
  }),
  components: {
    DashboardDrawer,
    AppNavDash,
  },
  computed: {
    ...mapGetters({
      snackAlert: "snackAlert",
    }),
  },
  methods: {
    onClickDrawer() {
      this.drawer = !this.drawer;
    },
  },
};
</script>